import { MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD } from '../data-loading/TableLoadingConstants';
import { mergeRowResponseFromTop } from 'owa-mail-list-response-processor';
import { action } from 'satcheljs/lib/legacy';
/**
 * Callback when load initial rows request succeeds
 * @param tableView to load
 * @param newRows to be merged
 * @param newTotalRowsInView the number of new total rows
 * @param searchFolderId the searchFolderId contained in the response message
 */
export default action('onLoadInitialRowsSucceeded')(function onLoadInitialRowsSucceeded(tableView, newRows, newTotalRowsInView, searchFolderId, folderId) {
    // In case of groups, we don't initially have the actual folder id when the tableView is created (similar to search folders in inbox),
    // So we get it in the response for findConversation call and update the serverFolderId.
    if (tableView.tableQuery.type == 2 /* Group */ && folderId) {
        tableView.serverFolderId = folderId.Id;
    }
    // If SearchFolderId is returned in response, set it on the tableView
    if (searchFolderId) {
        tableView.serverFolderId = searchFolderId.Id;
    }
    // Update rows in listview store
    // also log isDataUptodate only if the table is not being loaded for first time
    mergeRowResponseFromTop(newRows, tableView, newTotalRowsInView, false /* removeRemainingRowsAfterMerge */, tableView.isInitialLoadComplete /* shouldLogIsDataUptodate */);
    // Set the loaded index to max allowed on initial table load
    tableView.currentLoadedIndex = Math.min(MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD, tableView.rowKeys.length);
});
//# sourceMappingURL=onLoadInitialRowsSucceeded.js.map